export default __webpack_public_path__ + "static/media/left-live-mobile.fa4a5adc.svg";